import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";

class Option{
    constructor(public readonly text: string, public readonly value: boolean) {
    }
}

class TrueFalseOptions{
    readonly yes = new Option(translateTrueFalse(true), true);
    readonly no = new Option(translateTrueFalse(false), false);
    
    readonly options = [this.yes, this.no];
}

export default new TrueFalseOptions();